// extracted by mini-css-extract-plugin
module.exports = {"Preview":"MagazineIssue_Preview_Preview__0C2_S","Image":"MagazineIssue_Preview_Image__rspWQ","Text":"MagazineIssue_Preview_Text__ZFzM5"};